import styled from 'styled-components';
import { FileText, Layers, Mail } from 'styled-icons/feather';
import { Flex, Box } from 'reflexbox/styled-components';
import { lighten } from 'polished';
import Link from 'next/link';

import { colors } from '@/themes';
import Section from '@/components/section';
import TitleBase from '@/components/title';
import ParagraphBase from '@/components/paragraph';
import Card from '@/components/card';

const lightBlue = lighten(.05, colors.brand.primary);

const Title = styled(TitleBase)`
  color: ${props => props.theme.colors.typography.inverted};
`;

const Paragraph = styled(ParagraphBase)`
  color: ${props => props.theme.colors.typography.inverted};
  margin: 0 0 2em;
`;

const RightColumn = styled(Box)`
  ${Card} {
    display: flex;
    padding: 2em;

    svg {
      color: ${lightBlue};
      flex-shrink: 0;
      height: 3em;
      margin-right: 1.5em;
      width: 3em;
    }
  }

  a + a {
    display: block;
    margin-top: 2em;
  }

  a:hover {
    text-decoration: none;
  }
`;

const CardTitle = styled.h3`
  color: ${lightBlue};
  font-size: 2em;
  font-weight: 400;
  margin: 0 0 .5em;
`;

const CardDescription = styled(ParagraphBase)`
  margin-bottom: 0;
`;

const Why = () => {
  return (
    <Section angleBottomReverse backgroundColor={lightBlue}>
      <Title>What drives us</Title>
      <Flex flexWrap="wrap">
        <Box width={[1, 1, 1/2]} pr={[0, 0, '1em']}>
          <Paragraph>
            Everyone should have easy access to global capital markets, without high fees and repression. We’ve experienced first hand that unfortunately this is not the case everywhere.
          </Paragraph>
          <Paragraph>
            In order to pay people around the world we’ve had to stitch together various services and pay absurd fees just to pay honest people for honest work. In many parts of the world obtaining a bank account or accessing their funds in a timely manner is impossible. This is excluding people from the global economy and preventing them from improving their life.
          </Paragraph>
          <Paragraph>
            <em><strong>We believe that the ability to bank and transact is a fundamental human right. Without access to capital you are entirely isolated and unable to function in today’s society.</strong></em>
          </Paragraph>
          <Paragraph>
            The blockchain and other distributed ledger technologies lower the cost to transact and streamline the payment process by providing a secure, globally agreed upon settlement layer. We believe it’s this technology that is going to ensure banking and commerce becomes a human right and gives you more control over your own finances. We’re building the products that allow people to leverage this technology.
          </Paragraph>
        </Box>
        <RightColumn width={[1, 1, 1/2]} pl={[0, 0, '1em']}>
          <Link href="/press">
            <a>
              <Card clickable>
                <FileText />
                <div>
                  <CardTitle>Press Information</CardTitle>
                  <CardDescription>News, company info, and media resources and contact information.</CardDescription>
                </div>
              </Card>
            </a>
          </Link>
          <Link href="/branding">
            <a>
              <Card clickable>
                <Layers />
                <div>
                  <CardTitle>Branding and resources</CardTitle>
                  <CardDescription>Official logos, badges and buttons for your website, mobile app or print.</CardDescription>
                </div>
              </Card>
            </a>
          </Link>
          <Link href="/contact">
            <a>
              <Card clickable>
                <Mail />
                <div>
                  <CardTitle>Contact us</CardTitle>
                  <CardDescription>Get in touch with our sales, support or compliance teams.</CardDescription>
                </div>
              </Card>
            </a>
          </Link>
        </RightColumn>
      </Flex>
    </Section>
  );
};

export default Why;
